import React from 'react';
import { SmartphoneIcon, MonitorIcon, ArrowRightIcon, HeartPulseIcon, DownloadIcon, LogInIcon, ShieldCheckIcon } from 'lucide-react';
export function StickyFooter() {
  return <>
      {/* Main footer */}
      <footer className="w-full bg-text-dark text-white" aria-label="Site footer" data-id="element-722">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-723">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12" data-id="element-724">
            {/* Brand */}
            <div className="md:col-span-1" data-id="element-725">
              <div className="flex items-center gap-2 mb-4" data-id="element-726">
                <img src="https://cdn.magicpatterns.com/uploads/pi4C6Ke6dQudbV1eBciptk/Media_(1).jpg" alt="Care Nomads" className="h-10 w-auto object-contain rounded-lg" data-id="element-727" />
                <span className="font-bold text-xl" data-id="element-728">
                  Care<span className="text-accent-teal" data-id="element-729">Nomad</span>
                </span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-730">
                Canada's first nurse-led healthcare staffing marketplace.
                Real-time matching for facilities and workers.
              </p>
              <div className="flex flex-col gap-2" data-id="element-731">
                <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-732">
                  <span data-id="element-733">🍁</span>
                  <span data-id="element-734">Made in Canada · Toronto, ON</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-735">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-accent-teal" data-id="element-736" />
                  <span data-id="element-737">Licensed THA Agency # 12345678</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium" data-id="element-738">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-medical-blue" data-id="element-739" />
                  <span data-id="element-740">100% WSIB Insured</span>
                </div>
              </div>
            </div>

            <div data-id="element-741">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-742">
                Platform
              </h4>
              <ul className="space-y-2.5" data-id="element-743">
                <li data-id="element-744">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-745">
                    Find Workers
                  </a>
                </li>
                <li data-id="element-746">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-747">
                    Post a Shift
                  </a>
                </li>
                <li data-id="element-748">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-749">
                    Live Shift Board
                  </a>
                </li>
                <li data-id="element-750">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-751">
                    Savings Calculator
                  </a>
                </li>
                <li data-id="element-752">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-753">
                    Pricing
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-754">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-755">
                Company
              </h4>
              <ul className="space-y-2.5" data-id="element-756">
                <li data-id="element-757">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-758">
                    About Us
                  </a>
                </li>
                <li data-id="element-759">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-760">
                    Why Nurse-Led
                  </a>
                </li>
                <li data-id="element-761">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-762">
                    Blog
                  </a>
                </li>
                <li data-id="element-763">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-764">
                    Careers
                  </a>
                </li>
                <li data-id="element-765">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-766">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-767">
              <h4 className="font-semibold text-white text-sm mb-4 uppercase tracking-widest" data-id="element-768">
                Support
              </h4>
              <ul className="space-y-2.5" data-id="element-769">
                <li data-id="element-770">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-771">
                    Help Centre
                  </a>
                </li>
                <li data-id="element-772">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-773">
                    FAQ
                  </a>
                </li>
                <li data-id="element-774">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-775">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-776">
                  <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-777">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-778">
                  <a href="tel:+18005551234" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-779">
                    1-800-555-1234
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* App download CTAs */}
          <div className="border-t border-gray-700 pt-10" data-id="element-780">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-781">
              <div data-id="element-782">
                <h3 className="font-bold text-xl mb-1" data-id="element-783">
                  Download the Care Nomad App
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-784">
                  Available for healthcare workers and facility managers
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-785">
                <a href="#" className="flex items-center gap-3 bg-medical-blue hover:bg-medical-blue-dark px-5 py-3.5 rounded-xl transition-all group border border-medical-blue-light" aria-label="Download Employee App" data-id="element-786">
                  <SmartphoneIcon className="w-6 h-6 text-white flex-shrink-0" data-id="element-787" />
                  <div data-id="element-788">
                    <div className="text-white/70 text-xs" data-id="element-789">
                      For Healthcare Workers
                    </div>
                    <div className="text-white font-bold text-sm" data-id="element-790">
                      Employee App
                    </div>
                  </div>
                  <ArrowRightIcon className="w-4 h-4 text-white/60 group-hover:translate-x-0.5 transition-transform" data-id="element-791" />
                </a>
                <a href="#" className="flex items-center gap-3 bg-accent-teal hover:bg-accent-teal-dark px-5 py-3.5 rounded-xl transition-all group" aria-label="Access Client Portal" data-id="element-792">
                  <MonitorIcon className="w-6 h-6 text-white flex-shrink-0" data-id="element-793" />
                  <div data-id="element-794">
                    <div className="text-white/70 text-xs" data-id="element-795">
                      For Facilities & Managers
                    </div>
                    <div className="text-white font-bold text-sm" data-id="element-796">
                      Client Portal
                    </div>
                  </div>
                  <ArrowRightIcon className="w-4 h-4 text-white/60 group-hover:translate-x-0.5 transition-transform" data-id="element-797" />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-798">
            <p className="text-gray-500 text-xs" data-id="element-799">
              © 2025 Care Nomad Inc. All rights reserved. Registered in
              Ontario, Canada.
            </p>
            <div className="flex items-center gap-4" data-id="element-800">
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-801">
                Privacy
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-802">
                Terms
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-id="element-803">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Fast Action sticky bar — ALL screen sizes */}
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-medical-blue shadow-[0_-4px_24px_rgba(0,85,150,0.15)]" data-id="element-804">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-3" data-id="element-805">
          {/* Left: live indicator (desktop only) */}
          <div className="hidden sm:flex items-center gap-2 flex-shrink-0" data-id="element-806">
            <span className="w-2 h-2 bg-accent-teal rounded-full live-dot" data-id="element-807" />
            <span className="text-sm font-medium text-text-dark" data-id="element-808">
              <span className="font-bold text-medical-blue" data-id="element-809">14 caregivers</span>{' '}
              available now
            </span>
          </div>

          {/* Right: Fast Action buttons */}
          <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-810">
            <a href="#" className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-medical-blue hover:bg-medical-blue-dark text-white text-sm font-bold px-5 py-3 rounded-xl transition-colors" aria-label="Download the Care Nomad app" data-id="element-811">
              <DownloadIcon className="w-4 h-4" data-id="element-812" />
              Download App
            </a>
            <a href="#" className="flex-1 sm:flex-none flex items-center justify-center gap-2 border-2 border-medical-blue text-medical-blue hover:bg-soft-teal text-sm font-bold px-5 py-3 rounded-xl transition-colors" aria-label="Client login" data-id="element-813">
              <LogInIcon className="w-4 h-4" data-id="element-814" />
              Client Login
            </a>
          </div>
        </div>
      </div>
    </>;
}